import MinimumOrderQtyMessage from "@dana/Components/MinimumOrderQtyMessage";
import MultipleSaleQtyMessage from "@dana/Components/MultipleSaleQtyMessage";
import ProductAvailabilityState from "@dana/Store/Data/ProductAvailability/ProductAvailabilityState";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { ProductSubscriptionDto } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";

export interface ProductAddToCartButtonStyles {
    button?: ButtonPresentationProps;
    messageStyles?: InjectableCss;
    messageStylesWrapper?: InjectableCss;
}
interface OwnProps {
    labelOverride?: string;
    extendedStyles?: ProductAddToCartButtonStyles;
}
type Props = OwnProps &
    HasProductContext;

export const productAddToCartButtonStyles: ProductAddToCartButtonStyles = {};

const HiddenProductAddToCartButton = ({
    
    labelOverride,
    extendedStyles,
    ...otherProps
}: Props) => {

    const [styles] = useState(() => mergeToNew(productAddToCartButtonStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.messageStylesWrapper}>
            <>
                <StyledWrapper {...styles.messageStyles}>
                    <MultipleSaleQtyMessage />
                    <MinimumOrderQtyMessage />
                </StyledWrapper>

                <Button
                    {...styles.button}
                    disabled={true}
                    {...otherProps}
                >
                    {labelOverride ?? translate("Add to Cart")}
                </Button>
            </>
        </StyledWrapper>
    );
};
export default withProductContext(HiddenProductAddToCartButton);
